export const toHHMMSS = (secs) => {

    var sec_num = parseInt(secs, 10)/1000;
    var hours = Math.floor(sec_num / 3600)
    var minutes = Math.floor(sec_num / 60) % 60
    var seconds = Math.round(sec_num % 60)

    return [hours, minutes, seconds]
        .map(v => v < 10 ? "0" + v : v)
        .filter((v, i) => v !== "00" || i > 0)
        .join(":")
}


export const getHours = (data) => {
  const [hr, min] = data.split(".");
  return `${hr} hrs ${parseFloat((min * 60) / 100).toFixed(0)} min`;
};

export const getMin = (data) => {
  const second = Math.ceil(data);
  let s = second % 60;
  let m = Math.floor(second / 60);
  return `${m} min ${s} sec`;
};